const ErmsUrl = "https://pxbjz.yiqun169.com";
// const ErmsUrl = "https://pxbjz.getdreamstar.com";

export default {
  ErmsUrl
};



// WEBPACK FOOTER //
// ./src/api/etmsConfig.js